import { ERROR_MESSAGES } from "src/app/constants";
import { AccountAuthorization } from "./accountAuthorization";
import { validateAccountNumber } from "src/app/bank.config";

export class CustomerAccount {
    constructor(private _id?: number, private _bank?: string, private _accountNumber?: string, private _holderName?: string, private _createdAt?: Date, private _createdBy?: string, private _customerId?: number, private _contactId?: number, private _remark?: string, private _disabledBy?: string, private _disabledOn?: Date, private _disableRemark?: string) {
    }

    get CustomerId(): number {
        return this._customerId;
    }
    set CustomerId(value: number) {
        this._customerId = value;
    }

    get Remark(): string {
        return this._remark;
    }
    set Remark(value: string) {
        this._remark = value;
    }
    get ContactId(): number {
        return this._contactId;
    }
    set ContactId(value: number) {
        this._contactId = value;
    }
    get CreatedBy(): string {
        return this._createdBy;
    }
    set CreatedBy(value: string) {
        this._createdBy = value;
    }
    get CreatedAt(): Date {
        return this._createdAt;
    }
    set CreatedAt(value: Date) {
        this._createdAt = value;
    }
    get HolderName(): string {
        return this._holderName;
    }
    set HolderName(value: string) {
        this._holderName = value;
    }
    get AccountNumber(): string {
        return this._accountNumber;
    }
    set AccountNumber(value: string) {
        this._accountNumber = value;
    }
    get Bank(): string {
        return this._bank;
    }
    set Bank(value: string) {
        this._bank = value;
    }
    get Id(): number {
        return this._id;
    }
    set Id(value: number) {
        this._id = value;
    }

    get DisabledBy(): string { return this._disabledBy }
    set DisabledBy(value: string) { this._disabledBy = value }

    get DisabledOn(): Date { return this._disabledOn }
    set DisabledOn(value: Date) { this._disabledOn = value }

    get DisableRemark(): string { return this._disableRemark }
    set DisableRemark(value: string) { this._disableRemark = value }

    validate(isContact: boolean = false): string[] {
        const errors: string[] = [];
        if (isContact && this._contactId == null)
           errors.push(ERROR_MESSAGES.EMPTY_SELECTION('contact'));
        if (this._holderName == null || this._holderName.trim().length === 0)
            errors.push(ERROR_MESSAGES.EMPTY_FIELD('Account holder name'));
        if (this._bank == null || this._bank.trim().length === 0)
            errors.push(ERROR_MESSAGES.EMPTY_FIELD('Bank'));
        if (this._accountNumber == null || this._accountNumber.trim().length === 0)
            errors.push(ERROR_MESSAGES.EMPTY_FIELD('Account Number'));
        else if (!validateAccountNumber(this._bank, this._accountNumber))
            errors.push(ERROR_MESSAGES.INVALID_BANK_ACCOUNT);
        return errors;
    }
}


export interface IAPICustomerAccount {
    id: number,
    bank: string,
    account_number: string,
    holder_name: string,
    created_at: Date,
    created_by: string,
    customerId: number,
    contactId: number,
    remark: string
}


export interface AccountWithAuthorizations {
    account: CustomerAccount,
    authorizations: AccountAuthorization[];
}
